module.exports = __webpack_public_path__ + "img/xylophone-0.7bdd4941.png";